// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__bGdeL","main":"Burger_main__p9ASe","paper":"Burger_paper__qsl+y","header":"Burger_header__mf6ld","links":"Burger_links__BHnXH"};